__turbopack_context__.v({
  "actions": "FinishSetupBanner-module-scss-module__jGZpaa__actions",
  "app-download-logos": "FinishSetupBanner-module-scss-module__jGZpaa__app-download-logos",
  "check-icon": "FinishSetupBanner-module-scss-module__jGZpaa__check-icon",
  "circle-icon": "FinishSetupBanner-module-scss-module__jGZpaa__circle-icon",
  "download-info": "FinishSetupBanner-module-scss-module__jGZpaa__download-info",
  "download-text": "FinishSetupBanner-module-scss-module__jGZpaa__download-text",
  "downloaded-app-btn": "FinishSetupBanner-module-scss-module__jGZpaa__downloaded-app-btn",
  "finish-setup-desktop": "FinishSetupBanner-module-scss-module__jGZpaa__finish-setup-desktop",
  "finish-setup-tablet": "FinishSetupBanner-module-scss-module__jGZpaa__finish-setup-tablet",
  "icon": "FinishSetupBanner-module-scss-module__jGZpaa__icon",
  "logo-icons": "FinishSetupBanner-module-scss-module__jGZpaa__logo-icons",
  "qr-code-container": "FinishSetupBanner-module-scss-module__jGZpaa__qr-code-container",
  "qr-container": "FinishSetupBanner-module-scss-module__jGZpaa__qr-container",
  "qr-text": "FinishSetupBanner-module-scss-module__jGZpaa__qr-text",
  "setup-text": "FinishSetupBanner-module-scss-module__jGZpaa__setup-text",
  "step": "FinishSetupBanner-module-scss-module__jGZpaa__step",
  "steps": "FinishSetupBanner-module-scss-module__jGZpaa__steps",
  "steps-text": "FinishSetupBanner-module-scss-module__jGZpaa__steps-text",
  "tablet-icon": "FinishSetupBanner-module-scss-module__jGZpaa__tablet-icon",
  "tablet-icons": "FinishSetupBanner-module-scss-module__jGZpaa__tablet-icons",
  "title": "FinishSetupBanner-module-scss-module__jGZpaa__title",
});
